import { render, staticRenderFns } from "./TheInquiry.vue?vue&type=template&id=c1dfd046&scoped=true&lang=pug&"
import script from "./TheInquiry.vue?vue&type=script&lang=js&"
export * from "./TheInquiry.vue?vue&type=script&lang=js&"
import style0 from "./TheInquiry.vue?vue&type=style&index=0&id=c1dfd046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dfd046",
  null
  
)

export default component.exports